import * as React from "react";
import { SVGProps } from "react";

export const IconExternalMeeting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.2}
      y={0.2}
      width={16.6}
      height={16.1}
      rx={2.8}
      fill="#1976D2"
      stroke="#1976D2"
      strokeWidth={0.4}
    />
    <path
      d="M8.111 10.444h.778V8.89h1.555V8.11H8.89V6.556H8.11V8.11H6.556v.778H8.11v1.555zM5.778 12a.749.749 0 01-.55-.229.749.749 0 01-.228-.549V5.778c0-.214.076-.397.228-.55A.749.749 0 015.778 5h5.444c.214 0 .397.076.55.228a.749.749 0 01.228.55v5.444a.749.749 0 01-.229.55.749.749 0 01-.549.228H5.778z"
      fill="#fff"
    />
  </svg>
);
